import { useCallback, useState } from 'react';
import { useSelection } from '@logz-pkg/react-hooks';
import { SelectionInfo } from '../types';

export function useTableSelection(ref: React.MutableRefObject<HTMLDivElement | null>) {
  const [selectionInfo, setSelectionInfo] = useState<SelectionInfo | null>(null);
  const getElement = useCallback(() => ref.current?.querySelector('tbody') ?? null, [ref.current]);

  const handleSelectionChange = useCallback(
    (selection: Selection) => {
      const clearSelection = () => setSelectionInfo(null);

      if (!selection || selection.isCollapsed || selection.rangeCount === 0) {
        return clearSelection();
      }

      const selectedText = selection.toString().trim();

      const range = selection.getRangeAt(0);
      const container = range.commonAncestorContainer;
      const element = container instanceof Element ? container : container.parentElement;
      const td = element?.closest('td');

      if (!td) return clearSelection();

      const closestTbody = td.closest('tbody');
      const targetElement = getElement();

      if (closestTbody !== targetElement) {
        return clearSelection();
      }

      const { rowid: rowId, columnid: columnId } = td.dataset;

      if (!rowId || !columnId) return clearSelection();

      setSelectionInfo({ rowId, columnId, selectedText });
    },
    [getElement],
  );

  useSelection(getElement, handleSelectionChange);

  return selectionInfo;
}
